var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fa-star hover",class:_vm.isFavorite ? 'fa-solid' : 'fa-regular darken',on:{"click":function($event){$event.stopPropagation();return _vm.handleFavorite()}}})}
var staticRenderFns = []

export { render, staticRenderFns }